// extracted by mini-css-extract-plugin
export default {"container":"Bubble_container__KIzSU","title":"Bubble_title__RGrb8"};